import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import { RegistryPagination } from "./registry-pagination";
import { RegistryTopSection } from "./registry-top-section";
import { RegistryTable } from "./registry-data";
import {
  spreadsheetsLoadApplications,
  spreadsheetsLoadManagers,
} from "redux/slices/spreadsheets.slice";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "redux/types";
import { useURLParamsSpreadsheets } from "hooks";

const limit = 10;

export const RegistrySection = () => {
  const dispatch = useDispatch();
  const { spreadsheets } = useSelector(
    (state: IRootState) => state.spreadsheets
  );
  const { page, bin, compensationType, signedAtFrom, signedAtUntil } =
    useURLParamsSpreadsheets();

  const [curPg, setCurPg] = useState(page.get());
  const [maxPg, setMaxPg] = useState(page.get());

  const fetchList = async (pg) => {
    const offset = (pg - 1) * limit;
    dispatch(
      spreadsheetsLoadApplications({
        limit: limit,
        offset: offset,
        bin: bin.get() ? bin.get() : undefined,
        compensation_type: compensationType.get()
          ? compensationType.get()
          : undefined,
        signed_at_from: signedAtFrom.get() ? signedAtFrom.get() : undefined,
        signed_at_until: signedAtUntil.get() ? signedAtUntil.get() : undefined,
      })
    );
  };

  const setPageWithLoad = (pg) => {
    setCurPg(pg);
    page.set(pg);
    fetchList(pg);
  };

  useEffect(() => {
    fetchList(page.get());
    dispatch(spreadsheetsLoadManagers());
  }, []);

  useEffect(() => {
    setCurPg(page.get());
  }, [page.get()]);

  useEffect(() => {
    if (spreadsheets.value)
      setMaxPg(Math.ceil((spreadsheets.value?.all_count ?? 1) / limit));
  }, [spreadsheets.value]);

  return (
    <>
      <RegistryTopSection />
      <Container
        sx={{
          mt: "32px",
          minWidth: "100%",
          width: "100%",
        }}
      >
        <RegistryTable />
        {maxPg === 1 || maxPg === 0 ? null : (
          <RegistryPagination
            cur={curPg}
            max={maxPg}
            onClickNext={() => {
              setPageWithLoad(curPg + 1);
            }}
            onClickPrev={() => {
              setPageWithLoad(curPg - 1);
            }}
          />
        )}
      </Container>
    </>
  );
};
